import * as ArchiveStatus from '../../../../../shared/ArchiveStatus';
import { IBookingInfo } from '../Types';

export function isPhotoOrderArchived(archiveStatus: number) {
    return archiveStatus > ArchiveStatus.ArchivedCold;
}

export function lockPhotographer(bookingInfo: IBookingInfo): boolean {
    return bookingInfo.customerWantsClient === true;
}
